import { Button } from '@root/components'
import { motion } from 'framer-motion'
import styled from 'styled-components'

export const StyledPageContent = styled(motion.div).attrs({
  initial: { opacity: 0 },
  animate: { opacity: 1 }
})`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
  max-height: 600px;
  max-width: 450px;
  padding: ${({ theme }) => theme.spacing.xl}rem;
  border-radius: ${({ theme }) => theme.borderRadius.md}rem;
  background: ${({ theme }) => theme.colors.neutralWhite};
  overflow: auto;
  box-shadow: 0px 5px 10px 1px rgba(0, 0, 0, 0.1);
  align-items: center;
  gap: ${({ theme }) => theme.spacing.xl}rem;

  @media (max-width: 768px) {
    max-width: 100%;
    max-height: 100%;
  }
`

export const LogoContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  padding: ${({ theme }) => theme.spacing.md}rem;
  box-sizing: border-box;
`

export const StyledImg = styled.img`
  width: auto;
  height: 5rem;
`

export const StyledText = styled.p`
  text-align: left;
  max-width: 600px;
  margin-bottom: ${({ theme }) => theme.spacing.sm}rem;
  line-height: 1.5;
`

export const ActionBar = styled.div`
  display: flex;
  width: 100%;
  padding-top: ${({ theme }) => theme.spacing.md}rem;
  gap: ${({ theme }) => theme.spacing.md}rem;
  flex-wrap: wrap;
  justify-content: space-between;
`

export const StyledButton = styled(Button)`
  background: ${({ theme }) => theme.colors.ifBlue} !important;
`

export const Footer = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: ${({ theme }) => theme.spacing.sm}rem;
  padding: ${({ theme }) => theme.spacing.md}rem;
  margin-top: ${({ theme }) => theme.spacing.md}rem;
`
